import { useLocation } from 'react-use'
import { routesDef } from '../../../../config/routes'

export type UseCheckoutReturnUrlsResult = {
  success_url: string
  cancel_url: string
}

export const useCheckoutReturnUrls = ({ orderId }: { orderId: string }): UseCheckoutReturnUrlsResult => {
  const location = useLocation()
  const baseUrl = location.origin

  const cancel_url = `${baseUrl}${routesDef.OrderItemPaymentFailedPage.altPath({ _id: orderId })}`
  const success_url = `${baseUrl}${routesDef.OrderItemPaymentSuccessPage.altPath({ _id: orderId })}`

  return { success_url, cancel_url }
}
